import React from 'react';
import { siteInfo } from '../data/mock';

export const LegalPage = () => {
  return (
    <div className="min-h-screen bg-[#FDF8F3]">
      {/* Hero */}
      <section className="relative py-24 bg-[#2C1810]">
        <div className="max-w-7xl mx-auto px-6 text-center">
          <h1 className="text-5xl md:text-6xl font-serif font-bold text-white mt-4 mb-6">
            Mentions Légales
          </h1>
          <div className="w-20 h-1 bg-gradient-to-r from-[#C9A96E] to-[#A67B5B] mx-auto" />
        </div>
      </section>

      {/* Content */}
      <section className="py-20">
        <div className="max-w-4xl mx-auto px-6 space-y-8">
          <div className="bg-white rounded-2xl p-8 shadow-lg">
            <h2 className="text-2xl font-serif font-bold text-[#2C1810] mb-4">1. Informations légales</h2>
            <div className="space-y-3 text-[#5D4037]">
              <p><strong>Raison sociale :</strong> {siteInfo.name}</p>
              <p><strong>Adresse :</strong> {siteInfo.address}</p>
              <p><strong>Téléphone :</strong> {siteInfo.phone}</p>
              <p><strong>Email :</strong> {siteInfo.email}</p>
              <p><strong>Forme juridique :</strong> Entreprise individuelle</p>
              <p><strong>SIRET :</strong> 82889543300013 </p>
            </div>
          </div>

          <div className="bg-white rounded-2xl p-8 shadow-lg">
            <h2 className="text-2xl font-serif font-bold text-[#2C1810] mb-4">2. Hébergement</h2>
            <div className="space-y-3 text-[#5D4037]">
              <p><strong>Hébergeur :</strong> SAS OVH </p>
              <p><strong>Adresse : </strong> 2 RUE KELLERMANN 59100 ROUBAIX</p>
            </div>
          </div>

          <div className="bg-white rounded-2xl p-8 shadow-lg">
            <h2 className="text-2xl font-serif font-bold text-[#2C1810] mb-4">3. Propriété intellectuelle</h2>
            <p className="text-[#5D4037] leading-relaxed">
              L'ensemble de ce site relève de la législation française et internationale sur le droit d'auteur et la propriété intellectuelle. 
              Tous les droits de reproduction sont réservés, y compris pour les documents téléchargeables et les représentations iconographiques et photographiques.
            </p>
          </div>

          <div className="bg-white rounded-2xl p-8 shadow-lg">
            <h2 className="text-2xl font-serif font-bold text-[#2C1810] mb-4">4. Protection des données personnelles</h2>
            <p className="text-[#5D4037] leading-relaxed mb-4">
              Conformément à la loi « Informatique et Libertés » du 6 janvier 1978 modifiée et au Règlement Général sur la Protection des Données (RGPD), 
              vous disposez d'un droit d'accès, de rectification, de suppression et d'opposition aux données personnelles vous concernant.
            </p>
            <p className="text-[#5D4037] leading-relaxed">
              Pour exercer ces droits, vous pouvez nous contacter à l'adresse : {siteInfo.email}
            </p>
          </div>

          <div className="bg-white rounded-2xl p-8 shadow-lg">
            <h2 className="text-2xl font-serif font-bold text-[#2C1810] mb-4">5. Cookies</h2>
            <p className="text-[#5D4037] leading-relaxed">
              Ce site utilise des cookies uniquement pour améliorer l'expérience utilisateur. 
              Vous pouvez les désactiver dans les paramètres de votre navigateur.
            </p>
          </div>
        </div>
      </section>
    </div>
  );
};
